import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'

interface RowItemProps {
  heading: string
  detail?: string
  showDot?: boolean
  headingTextColor?: ColorOptions
  detailTextColor?: ColorOptions
  isFullWidth?: boolean
}

export const RowItem = ({
  heading,
  detail,
  showDot = true,
  headingTextColor = 'PRIMARY_GREY',
  detailTextColor = 'BLACK_21',
  isFullWidth = true,
}: RowItemProps) => {
  return (
    <Box {...styles.container(isFullWidth)}>
      <Box f={isFullWidth ? 1 : undefined}>
        <Text {...styles.title} color={headingTextColor}>
          {heading}
        </Text>
      </Box>
      {showDot && (
        <Text {...styles.title} color={headingTextColor}>
          :
        </Text>
      )}
      <Box f={isFullWidth ? 1 : undefined} alignItems={'flex-end'} ml={isFullWidth ? undefined : 12}>
        <Text {...styles.title} color={detailTextColor}>
          {detail}
        </Text>
      </Box>
    </Box>
  )
}

const styles = {
  container: (isFullWidth: boolean) =>
    ({
      flexDirection: 'row',
      pv: 6,
      width: isFullWidth ? '100%' : undefined,
    } as BoxProps),
  title: {
    fontFamily: 'jioType-medium',
    fontSize: 12,
    color: 'PRIMARY_GREY',
  } as TextProps,
}
